@use './variables' as *;
@use '../../styles/abstracts/break-points' as *;

:host {
  display: $input-host-display;
  width: $input-width;
  min-width: $input-min-width;
  max-width: $input-max-width;
}

@mixin status($inputColor, $inputBorderColor, $inputLabelColor, $statusText) {
  .input-element {
    color: $inputColor;
    border-color: $inputBorderColor;
  }

  .input-label {
    color: $inputLabelColor;
  }

  .status-text {
    color: $statusText;
  }
}

.input-wrapper {
  position: relative;
  display: $input-display;
  width: $input-width;
  min-width: $input-min-width;
  max-width: $input-max-width;

  &.error {
    @include status(
      $input-error-color,
      $input-error-border-color,
      $input-error-label-color,
      $input-error-label-color
    );
  }

  &.success {
    @include status(
      $input-success-color,
      $input-success-border-color,
      $input-success-label-color,
      $input-success-label-color
    );
  }

  &:not(.with-status):hover {
    .input-element:not([disabled]):not([readonly]) {
      color: $input-hover-color;
      border-color: $input-hover-border-color;
      background-color: $input-hover-background-color;
    }
  }

  .required-mark {
    color: $input-mark-required-color;
  }

  .input-label {
    display: block;
    font-family: $input-font-family;
    margin-top: $input-label-margin-top;
    margin-right: $input-label-margin-right;
    margin-bottom: $input-label-margin-bottom;
    margin-left: $input-label-margin-left;
  }

  .status-text {
    display: block;
    font-family: $input-font-family;
    font-size: $input-status-text-font-size;
    font-weight: $input-status-text-font-weight;
    font-family: $input-status-text-font-family;
    line-height: $input-status-text-line-height;
    margin-top: $input-status-text-margin-top;
    margin-right: $input-status-text-margin-right;
    margin-bottom: $input-status-text-margin-bottom;
    margin-left: $input-status-text-margin-left;
  }
}

.input-element-wrapper {
  position: relative;
}

.input-element {
  display: $input-display;
  width: 100%;
  font-family: $input-font-family;
  font-size: $input-font-size;
  line-height: $input-line-height;
  margin-top: $input-margin-top;
  margin-left: $input-margin-left;
  margin-bottom: $input-margin-bottom;
  margin-right: $input-margin-right;
  padding-top: $input-padding-top;
  padding-left: $input-padding-left;
  padding-bottom: $input-padding-bottom;
  padding-right: $input-padding-right;
  border-radius: $input-border-radius;
  color: $input-color;
  border: $input-border-width $input-border-style $input-border-color;

  &:focus {
    outline: none;
    box-shadow: 0 0 0 $input-focus-outline-width $input-focus-outline-color;
  }

  &[disabled] {
    background-color: $input-disabled-background-color;
    color: $input-disabled-color;
    border-color: $input-disabled-border-color;
  }

  &[readonly] {
    color: $input-readonly-color;
    border-color: $input-readonly-border-color;
  }

  &::placeholder {
    color: $input-placeholder-color;
  }
}

.input-icon-left {
  left: $input-padding-left;
}

.input-icon-right {
  right: $input-padding-right;
}

.input-icon-left,
.input-icon-right {
  display: inline-block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

.with-icon {
  .input-element {
    padding-left: $input-with-icon-left-padding-left;
  }
}

.has-value {
  .input-element {
    padding-right: $input-with-icon-right-padding-right;
  }
}

.hidden {
  display: none;
}

@media (max-width: $breakpoint-mobile) {
  :host {
    --air-input-width: #{$mobile-input-width};
    width: $mobile-input-width;
  }

  .input-wrapper {
    --air-input-width: #{$mobile-input-width};
    width: $mobile-input-width;
  }
}
